module.exports = __webpack_public_path__ + "static/media/sound.49dd03e9.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/sound.ogg
// module id = 50
// module chunks = 0